import React, { useState } from "react";
import {
  Home,
  Book,
  Search,
  Person,
  EventNote,
  Payment,
  CalendarToday,
  RateReview,
  Tune,
  Settings,
  Menu as MenuIcon,
  Close as CloseIcon,
  Person2,
  AdminPanelSettings,
} from "@mui/icons-material";
import classes from "./profileSideMenu.module.css";
import useAuth from "../../../hooks/useAuth";

const menuItemsUser = [
  { name: "Dashboard", icon: <Home />, navigateTo: "home" },
  { name: "Bookings", icon: <Book />, navigateTo: "bookings" },
  { name: "Find Artists", icon: <Search />, navigateTo: "findArtist" },
  { name: "Transactions", icon: <Person />, navigateTo: "transaction" },
  // { name: "My Jobs", icon: <Person2 />, navigateTo: "jobs" },
  { name: "Profile", icon: <Person />, navigateTo: "profile" },
];

const menuItemsArtist = [
  { name: "Dashboard", icon: <Home />, navigateTo: "home" },
  { name: "Bookings", icon: <CalendarToday />, navigateTo: "bookings" },
  {
    name: "Create Packages",
    icon: <EventNote />,
    navigateTo: "createPackages",
  },
  { name: "Payments", icon: <Payment />, navigateTo: "payments" },
  { name: "Testimonials", icon: <RateReview />, navigateTo: "testimonials" },
  { name: "Preferences", icon: <Tune />, navigateTo: "preferences" },
  { name: "Settings", icon: <Settings />, navigateTo: "settings" },
  // { name: "My Jobs", icon: <Person2 />, navigateTo: "jobs" },
];

const ProfileSideMenu = ({
  activeSection,
  setActiveSection,
  isUserAnArtist = false,
  artistProfile,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user } = useAuth();

  if (user?.type === "artist") {
    isUserAnArtist = true;
  }

  // Generate the menu items based on user type and email
  const getMenuItems = () => {
    if (!isUserAnArtist) return menuItemsUser;

    const artistMenuItems = [
      { name: "Dashboard", icon: <Home />, navigateTo: "home" },
      { name: "Bookings", icon: <CalendarToday />, navigateTo: "bookings" },
      {
        name: "Create Packages",
        icon: <EventNote />,
        navigateTo: "createPackages",
      },
      { name: "Payments", icon: <Payment />, navigateTo: "payments" },
      {
        name: "Testimonials",
        icon: <RateReview />,
        navigateTo: "testimonials",
      },
      { name: "Preferences", icon: <Tune />, navigateTo: "preferences" },
      { name: "Settings", icon: <Settings />, navigateTo: "settings" },
      // { name: "Jobs", icon: <Person2 />, navigateTo: "jobs" },
    ];

    // Only add the Admin menu item if the email is support@artistnextdoor.in
    const isAdmin = artistProfile?.email === "support@artistnextdoor.in";

    if (isAdmin) {
      artistMenuItems.push({
        name: "Admin",
        icon: <AdminPanelSettings />,
        navigateTo: "admin",
      });
    }

    return artistMenuItems;
  };

  const menuItems = getMenuItems();

  const handleItemClick = (navigateTo) => {
    setActiveSection(navigateTo);
    setMenuOpen(false); // Close menu when item is clicked on mobile
  };

  return (
    <div className={classes.outerMostContainer}>
      <div
        className={classes.menuToggle}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <CloseIcon /> : <MenuIcon />}
        <span>Menu</span>
      </div>

      <ul className={`${classes.menuList} ${menuOpen ? classes.menuOpen : ""}`}>
        {menuItems.map((item, index) => (
          <li
            key={index}
            className={`${classes.menuItem} ${
              activeSection === item.navigateTo ? classes.activeMenuItem : ""
            }`}
            onClick={() => handleItemClick(item.navigateTo)}
          >
            {item.icon}
            <span
              className={
                item.navigateTo === activeSection ? classes.highlight : ""
              }
            >
              {item.name}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProfileSideMenu;
